import { combineReducers } from 'redux'
import { i18nReducer } from 'react-redux-i18n';
import locationReducer from './location'
import loginReducer from '../routes/Login/modules/login'
import userReducer from '../routes/Login/modules/user'
import stepReducer from '../layouts/Content/modules/step'
import loadingContentReducer from '../layouts/Content/modules/loadingContent'
import categoriesReducer from '../components/Categories/modules/categories'
import productsReducer from '../components/Products/modules/products'
import billersReducer from '../components/Billers/modules/billers'
import shoppingCartReducer from '../components/ShoppingCart/modules/shoppingCart'
import appReducer from './application'
import customerReducer from './customer'
import timerReducer from './timer'
import viewStateReducer from './viewState'
import reportsReducer from '../components/Reports/modules/reports'
import errorReducer from '../components/shared/ErrorOverlay/modules/error'
import accountReducer from '../layouts/Content/modules/account'
import transactionReducer from '../components/Transactions/modules/transactions'
import scannerReducer from '../components/Devices/Scanner/modules/scanner'
import clerkReducer from '../components/Clerks/modules/clerks';

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    i18n: i18nReducer,
    location: locationReducer,
    loadingContent: loadingContentReducer,
    login: loginReducer,
    user: userReducer,
    clerks: clerkReducer,
    view_state: viewStateReducer,
    step: stepReducer,
    reports: reportsReducer,
    categories: categoriesReducer,
    products: productsReducer,
    billers: billersReducer,
    app: appReducer,
    customer: customerReducer,
    cart: shoppingCartReducer,
    timer: timerReducer,
    error: errorReducer,
    account_tab: accountReducer,
    transactions: transactionReducer,
    scanner: scannerReducer,
    ...asyncReducers
  })
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers))
};

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js